<template>
  <v-container
    id="upload-slip-success-page"
    class="fill-height flex-column justify-center mt-4">
    <img
      src="/svg/tick.svg"
      alt="Tick Svg"
      height="150px" />

    <div class="text-center primary--text font-weight-bold mt-8 _fs-36">
      คุณได้ทำการแจ้งหลักฐานการชำระเงินสำเร็จแล้ว
    </div>

    <div class="text-center mt-4 _fs-20">
      เจ้าหน้าที่จะทำการตรวจสอบและแจ้ง
      <span class="font-weight-bold">ยืนยันการเปิดใช้บริการภายใน 1-2 วันทำการ</span>
    </div>

    <div
      v-if="isJuristicCustomer"
      class="error--text text-center mt-4 _fs-16">
      ***กรณียอดชำระเกิน 1,000 บาท รบกวนลูกค้าส่งเอกสาร หัก ณ ที่จ่าย ตัวจริงกลับมาที่ บริษัท
      เซลสุกิ จำกัด
      <br />
      ตามรายละเอียดที่ระบุในเอกสารใบเสนอราคา
    </div>

    <div class="text-center font-weight-bold mt-12 _fs-24">
      LINE Agency by Sellsuki เพื่อนคู่คิด ทำธุรกิจออนไลน์
    </div>

    <div
      class="mt-4 mt-md-10"
    >
      <v-row>
        <v-col
          cols="12"
          sm="6"
          class="d-flex justify-center align-center"
        >
          <router-link
            :to="{
              name: 'Privilege'
            }"
            class="link"
          >
            <v-card
              outlined
              height="320"
              width="315"
              class="pa-4 d-flex flex-column justify-center align-center rounded-xl"
            >
              <img
                class="mb-4 mb-sm-0"
                src="/svg/privilege/e-book.svg"
                alt="e-book"
                width="120">

              <div class="_fs-24 mt-8">
                คู่มือใช้ LINE ขั้นเทพ
              </div>
              <div class="_fs-14 error--text">
                *คุณสามารถ Download ได้ที่หัวข้อ "สิทธิพิเศษ"
              </div>
            </v-card>
          </router-link>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          class="d-flex justify-center align-center pl-3 pl-sm-6"
        >
          <a
            href="https://www.youtube.com/watch?v=EdX77N8FF2k&list=PL2b_44Mp-d_bdgO1iUD5HzsMe_y7rNZj4"
            target="_blank"
            class="link"
          >
            <v-card
              outlined
              height="320"
              width="315"
              class="pa-4 rounded-xl"
            >
              <div class="fill-height d-flex flex-column justify-center align-center">
                <img
                  class=""
                  src="/svg/contact-us/youtube.svg"
                  alt="youtube ssk"
                  width="165">

                <div class="_fs-24 mt-8">
                  Youtube Channel SSK
                </div>
              </div>
            </v-card>
          </a>
        </v-col>
      </v-row>
    </div>

    <v-btn
      class="mt-8"
      color="primary"
      rounded
      min-width="200"
      exact
      :to="{ name: 'Home' }">
      กลับสู่หน้าหลัก
    </v-btn>

    <qr-line />

    <rating-dialog
      :show="dialog"
      :order-data="order"
      @submit="onSubmit"
      @close="onCloseDialog"
    />
  </v-container>
</template>

<script>
import { mapWaitingActions } from 'vue-wait'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    RatingDialog: () => import('@/components/RatingDialog'),
    qrLine: () => import('@/components/QRLINE.vue')
  },
  data() {
    return {
      dialog: false,
      order: []
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    isJuristicCustomer() {
      return this.$utils.isJuristicCustomer(
        this.userProfile.activeLineOfficialAccount?.customerTypeId || null
      )
    },
    hasOrder() {
      return !!this.$route.params?.order
    }
  },
  async mounted() {
    const { order } = this.$route.params
    if (this.hasOrder) {
      this.dialog = true
      this.order = order
    }

    this.$utils.removeKPaymentChargeId()
  },
  methods: {
    ...mapActions({
      createFeedback: 'Feedback/createFeedback'
    }),
    ...mapWaitingActions('Feedback', {
      createFeedback: 'app loading'
    }),
    onSubmit(data) {
      if (this.hasOrder) {
        const { order } = this.$route.params

        this.createFeedback({
          order: order._id,
          code: order.code,
          basicId: order.basicId,
          rating: data.rating,
          comment: data.description,
          customerName: `${order.firstName} ${order.lastName}`,
          email: order.email,
          phone: order.tel
        }).then(() => {
          this.dialog = false
          this.$swal({
            title: 'แจ้งหลักฐานชำระเงินเรียบร้อย',
            html: 'สามารถดาวน์โหลดใบเสร็จรับเงิน/ใบกำกับภาษี<br>ได้ที่หน้ารายการสั่งซื้อ ภายใน 1-3 วันทำการ',
            icon: 'success',
            confirmButtonText: 'ตกลง'
          })
        })
      }
    },
    async onCloseDialog() {
      this.dialog = false
      await this.$swal({
        title: 'แจ้งหลักฐานชำระเงินเรียบร้อย',
        html: 'สามารถดาวน์โหลดใบเสร็จรับเงิน/ใบกำกับภาษี<br>ได้ที่หน้ารายการสั่งซื้อ ภายใน 1-3 วันทำการ',
        icon: 'success',
        confirmButtonText: 'ตกลง'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
._qr-line-image {
  right: 0;
  top: 0;
  z-index: 2;
}
.link {
  text-decoration: none;
}
</style>
